export default __webpack_public_path__ + "static/BAP_4349-Verbessert-NR_rgb_fine-bef904fe24c2195ae5cc1506282c3ed9.jpg";